import {getEmpresasFiltered} from "../Empresas/EmpresaService";
import {getFinanceiroDashboard} from "../Financeiro/FinanceiroService";
import {listLicencas} from "../Licencas/LicencasService";
import {listCatalogEntity} from "../Sistemas/SistemasService";

export const getHomeDashboardData = async () => {
    const [empresas, sistemas, licencas, financeiro] = await Promise.allSettled([
        getEmpresasFiltered({page: 1, pageSize: 5, sortBy: 'criado_em', order: 'desc'}),
        listCatalogEntity('sistemas', {page: 1, pageSize: 5, sortBy: 'nome', order: 'asc'}),
        listLicencas({page: 1, pageSize: 5, sortBy: 'atualizado_em', order: 'desc'}),
        getFinanceiroDashboard(),
    ]);

    return {empresas, sistemas, licencas, financeiro};
};
